import { render, staticRenderFns } from "./CardImageLandScape.vue?vue&type=template&id=60228fd0&scoped=true"
import script from "./CardImageLandScape.vue?vue&type=script&lang=js"
export * from "./CardImageLandScape.vue?vue&type=script&lang=js"
import style0 from "./CardImageLandScape.vue?vue&type=style&index=0&id=60228fd0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60228fd0",
  null
  
)

export default component.exports